export const PACKAGE_NAME = 'jiraServiceDeskKnowledgeHub';
export const NATIVE_CONFLUENCE = 'NATIVE_CONFLUENCE';
export const SERVER_CONFLUENCE = 'SERVER_CONFLUENCE';
export const CROSS_SITE_CONFLUENCE = 'CROSS_SITE_CONFLUENCE';
export const SHAREPOINT = 'SHAREPOINT';
export const GOOGLE_DRIVE = 'GOOGLE_DRIVE';
